import React, { Component } from 'react';
import { Tenant } from 'models/Blip/Index';
import { TenantService } from 'connection/TenantService';
import { getTeam } from 'services/CeberusApiService';
import { BaseRequest } from 'models/request/Index';
import { TeamResponse, TeamPermissionsResponse } from 'models/response/Index';
import { Tag, Table, Icon } from 'antd';
import { PushNotification } from 'utils/PushNotification';
import { SearchTable } from 'components/SearchTable';

const TEAM = 'team';
const { Column } = Table;

const handleSearch = (selectedKeys: string, confirm: Function) => (): void => {
  confirm();
};

const handleReset = (clearFilters: Function) => (): void => {
  clearFilters();
};

export class Team extends Component<BaseRequest> {
  
  tenantSelected: Tenant;

  async componentDidMount() {
    await this.loadPage();
  }

  state = {
    isLoading: true,
    teamGroup: new Array<TeamResponse>()
  }

    loadPage = async () : Promise<void> =>{
    try {
      this.setState({ isLoading: true });
      this.tenantSelected = TenantService.getSelectedTenant();
        const teamResponse = await getTeam({ ...this.props, ClusterName: this.tenantSelected.name });
      this.setState({ teamResponse });
      this.mountTeamObject(teamResponse);
    } catch (error) {
      PushNotification.httpError(error);
      }finally{
      this.setState({ isLoading: false });
    }
    }

    mountTeamObject = (teamResponse: Array<TeamResponse>) : void =>{
      const teamGroup = Object.values(teamResponse.reduce((userMap, value) => {
        const key = value.userIdentity
        const item = userMap[key] || {
          userIdentity: key,
          isAdmin: false,
          permissions: new Array<TeamPermissionsResponse>()
        }
        item.isAdmin = item.isAdmin || value.permissionId === TEAM
        item.permissions = item.permissions.concat({
          permissionId: value.permissionId,
          updateDate: value.updateDate,
          actions: value.actions,
        })
        userMap[key] = item
        return userMap
      }, []))

    this.setState({ teamGroup });
  };

  filterByUser = (record: any, value: any): boolean => {
    const lowerCasedValue = value.toLowerCase();
    return record.userIdentity.toLowerCase().includes(lowerCasedValue);
  };

  render() {
    let searchInput;

    return (
      <div>
        <Table
          dataSource={this.state.teamGroup}
          rowKey={(record) => record.userIdentity}
          loading={this.state.isLoading}
          expandedRowRender={(rowElement) => (
            <Table dataSource={rowElement.permissions} pagination={false} rowKey={(record: TeamResponse) => record.permissionId}>
              <Column title="Area" dataIndex="permissionId" key="permissionId" />
              <Column title="Permissions" dataIndex="actions" key="actions" render={(permissions) => (
                <span>
                  {permissions.map((p) => (
                    <Tag key={p}>{p}</Tag>
                  ))}
                </span>
              )} />
            </Table>)} >
          <Column
            title="User"
            dataIndex="userIdentity"
            key="userIdentity"
            onFilter={(value, record) => this.filterByUser(record, value)}
            filterIcon={(filtered) => (
              <Icon type="search" style={{ color: filtered ? '#108ee9' : '#aaa' }} />
            )}
            filterDropdown={({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
              <SearchTable
                onSetRef={(e) => (searchInput = e)}
                onSetSelectedKeys={setSelectedKeys}
                selectedKeys={selectedKeys}
                confirm={confirm}
                clearFilters={clearFilters}
                onSearch={handleSearch}
                onReset={handleReset}
              />
            )}
          />
          <Column title="Is Admin" dataIndex="isAdmin" render={isAdmin => (
              <span> { isAdmin && <Tag>Admin</Tag> } </span>
            )}/>
          </Table>
        </div>
      )
    }
}
